import React from 'react';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import crecerForms from '../../../services/api/crecer';
import reportService from '../../../services/api/reportService';
import AllSurveyAnswers from '../../../containers/crecer/surveys/AllSurveyAnswers';
import { AdminTableSection } from 'src/assets/styles/components/AdminTable';

const SurveyAnswers = (props) => {
  const [allAnswers, set_allAnswers] = React.useState([]);
  const [loading, set_loading] = React.useState(null);
  const [showAnswers, set_showAnswers] = React.useState(null);
  const [inputs, setInputs] = React.useState({});

  React.useEffect(() => {
    getInfo();
  }, []);

  function getAttendantInfo() {
    set_loading(false);

    let filters = {};
    Object.entries(inputs)
      .filter((input) => input[1] != null)
      .forEach((element) => {
        filters[element[0]] = element[1];
      });

    let body = filters;
    let URL = `/crecer/getSurveyAnswersReport`;
    let fileName = `InformeCrecerEncuestas.xlsx`;

    reportService
      .getReport({ URL, fileName, body })
      .then(() => {
        set_loading(true);
      })
      .catch((error) => {
        if (error.response) Swal.fire(error.response.data.message);
        set_loading(true);
      });
  }

  function getInfo() {
    set_loading(true);

    let filters = {};
    Object.entries(inputs)
      .filter((input) => input[1] != null)
      .forEach((element) => {
        filters[element[0]] = element[1];
      });

    let body = filters;

    crecerForms
      .getSurveyAnswers(body)
      .then((response) => {
        if (response.data.success) {
          set_allAnswers(response.data.Answers);
        }
      })
      .catch((error) => {
        if (error.response) Swal.fire(error.response.data.message);
      })
      .finally(() => set_loading(false));
  }

  const selectHandle = (a, { value, name }) => {
    setInputs({ ...inputs, [name]: value });
  };

  const handleInputs = (event) => {
    let name = event.target.name;
    let value = event.target.value;
    setInputs({ ...inputs, [name]: value });
  };

  return (
    <AdminTableSection>
      <AllSurveyAnswers
        getAttendantInfo={getAttendantInfo}
        showAnswers={showAnswers}
        getInfo={getInfo}
        handleInputs={handleInputs}
        inputs={inputs}
        selectHandle={selectHandle}
        allAnswers={allAnswers}
        set_showAnswers={set_showAnswers}
        loading={loading}
        {...props}
      />
    </AdminTableSection>
  );
};

export default SurveyAnswers;
